var Handlebars = require('/var/www/html/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"l-time-step-title\"></div>\n<div class=\"l-time-step-staff\"></div>\n<div class=\"l-time-step-calendar\"></div>\n";
},"useData":true});